/* Sheet, toast and clipboard helpers carried over from the prototype. */
import { dmy, esc } from "../domain/format";
import { ic } from "./icons";

const $layer = () => document.getElementById("layer")!;

let sheetCleanup: (() => void) | null = null;
export function openSheet(html: string, mount?: (sh: HTMLElement) => void | (() => void)) {
  closeSheet();
  $layer().innerHTML = `<div class="scrim" data-do="scrim"><div class="sheet" role="dialog" aria-modal="true"><div class="grab"></div>${html}</div></div>`;
  const sh = $layer().querySelector<HTMLElement>(".sheet")!;
  if (mount) sheetCleanup = mount(sh) || null;
}
export function closeSheet() { if (sheetCleanup) sheetCleanup(); sheetCleanup = null; $layer().innerHTML = ""; }

export const head = (title: string, iconHTML = "") =>
  `<div class="sh-head">${iconHTML}<h3>${esc(title)}</h3><button class="iconbtn" data-do="close" aria-label="ปิด">${ic("x")}</button></div>`;
export const datesHTML = (o: { createdAt: string; updatedAt: string }) =>
  `<dl class="dates"><dt>สร้างเมื่อ</dt><dd>${dmy(o.createdAt)}</dd><dt>แก้ไขล่าสุด</dt><dd>${dmy(o.updatedAt)}</dd></dl>`;

let toastT: ReturnType<typeof setTimeout> | undefined;
export function toast(msg: string) {
  document.querySelector(".toast")?.remove();
  const t = document.createElement("div"); t.className = "toast"; t.setAttribute("role", "status");
  const icon = document.createElement("span"); icon.className = "toast-icon";
  const success = /แล้ว/.test(msg) && !/ไม่ได้|ไม่มี|ไม่สำเร็จ/.test(msg);
  icon.textContent = success ? "✓" : "i";
  t.classList.toggle("toast-success", success);
  const label = document.createElement("span"); label.className = "toast-label"; label.textContent = msg;
  const close = document.createElement("button"); close.type = "button"; close.className = "toast-close"; close.textContent = "ตกลง"; close.setAttribute("aria-label", "ปิดข้อความแจ้งเตือน"); close.onclick = () => t.remove();
  t.append(icon, label, close);
  document.body.appendChild(t); clearTimeout(toastT); toastT = setTimeout(() => t.remove(), 4000);
}

export function copyText(text: string, el: Element | null) {
  const fallback = () => {
    let ok = false;
    if (el) {
      if (el instanceof HTMLTextAreaElement) el.select();
      else { const r = document.createRange(); r.selectNodeContents(el); const s = getSelection(); s?.removeAllRanges(); s?.addRange(r); }
      try { ok = document.execCommand("copy"); } catch { /* not allowed */ }
    }
    toast(ok ? "คัดลอกแล้ว" : "คัดลอกอัตโนมัติไม่ได้ ข้อความถูกเลือกไว้แล้ว กดคัดลอกเองได้");
  };
  if (navigator.clipboard?.writeText) navigator.clipboard.writeText(text).then(() => toast("คัดลอกแล้ว"), fallback);
  else fallback();
}
